import { PageHeader, buttonVariants } from '@folio/components';
import { IntermediaryGeneralModule, IntermediaryTabsModule } from '@folio/modules';
import { useQuery } from '@tanstack/react-query';
import { legacyPermissionsControllerAtMeQueryOptions } from 'korint-sdk';
import { Loader2, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';

export function BrokerageFirmList() {
  const { data: brokerageFirmId } = useQuery({
    ...legacyPermissionsControllerAtMeQueryOptions(),
    select: data => data.brokerageFirmId,
  });

  return (
    <>
      <PageHeader
        title="Distributeurs"
        right={
          brokerageFirmId ? (
            <Link
              className={buttonVariants({ size: 'sm' })}
              to={`/brokerage-firm/${brokerageFirmId}/invitation/`}
            >
              <Plus className="mr-2 size-4" /> Nouveau garage
            </Link>
          ) : (
            <button
              type="button"
              className={buttonVariants({ size: 'sm', variant: 'secondary' })}
              disabled
              title="Chargement"
            >
              <Loader2 className="mr-2 size-4 animate-spin" /> Nouveau garage
            </button>
          )
        }
      />
      <div className="flex flex-col gap-4">
        <IntermediaryGeneralModule />
        <IntermediaryTabsModule />
      </div>
    </>
  );
}
